// extracted by mini-css-extract-plugin
export default {"date":"DateText_date__DuXgp"};